import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const StartPage = lazy(() => import('~/features/catalog-enrichment/pages/start-page'));

/** /catalog-enrichment: sends returning users to their batches, shows Get started to a new tenant. */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-enrichment/')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <StartPage />
    </Suspense>
  ),
});
